import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/AuthContext'
import PestanasAdmin from '../../components/admin/PestanasAdmin'

// Administración > Personas: the register, the accounts that sign in as them
// and the duplicates, one menu entry with three tabs.
export default function AdminGrupoPersonas({ children }) {
  const { t } = useTranslation('nav')
  const { hasRole } = useAuth()
  return (
    <>
      <PestanasAdmin tabs={[
        { to: '/admin/personas', label: t('items.adminPersonas') },
        { to: '/admin/cuentas', label: t('items.adminCuentas') },
        ...(hasRole('admin') ? [{ to: '/admin/duplicados', label: t('items.adminDuplicados') }] : []),
      ]} />
      {children}
    </>
  )
}
